export default __webpack_public_path__ + "static/media/Preloader.75e6558e.gif";